import React, { FC } from 'react';

import { observer } from 'mobx-react-lite';
import { Button, ButtonProps, styled, darken } from '@mui/material';

interface Props {
  label: string;
  onClick?: () => void;
  btnProps?: ButtonProps;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  disabled?: boolean;
}

const StyledButton = styled(Button)<ButtonProps>(({ theme }) => ({
  color: theme.palette.background.paper,
  backgroundColor: theme.palette.primary.main,
  borderRadius: '3px',
  width: '100%',

  // on hover change background color
  '&:hover': {
    backgroundColor: darken(theme.palette.primary.main, 0.4),
    color: theme.palette.background.paper,
  },
}));
const ThemedButton: FC<Props> = observer(props => {
  const { label, onClick, startIcon, endIcon, disabled } = props;

  return (
    <StyledButton
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}
      onClick={onClick}
      sx={{
        letterSpacing: 2.38,
        fontWeight: 'light',
        fontFamily: 'BrixSansRegular',
      }}
    >
      {label}
    </StyledButton>
  );
});

export default ThemedButton;
